import MessageBanner from './messageBanner.ui';

export default MessageBanner;
